/* eslint-disable */
import { Affix, Button, Drawer } from 'antd'
import moment from 'moment'
import { SlidersHorizontal } from 'phosphor-react'
import React, { useEffect, useState } from 'react'
import { RiCloseFill } from 'react-icons/ri'
import Loader from 'react-loader-spinner'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Route, useLocation } from 'react-router-dom'
import useMedia from 'use-media'
import './App.css'
import * as s from './App.styles'
import ErrorPage from './components/ErrorPage'
import Filters from './components/Filters'
import HelmetComponent from './components/Helmet'
import JobDetails from './components/Jobs/JobDetails'
import JobList from './components/Jobs/JobList'
import { companyFetched, jobsFetched } from './redux/reducers/companyReducer'
import { getCompany, getFilteredCompany } from './services/companyService'

const App = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const isSmallScreen = useMedia({ maxWidth: 800 })
  const store = useSelector((state) => state)
  const [status, setStatus] = useState('idle')
  const [jobs, setJobs] = useState([])
  const [company, setCompany] = useState(null)
  const [filters, setFilters] = useState({})
  const [locations, setLocations] = useState([])
  const [contractTypes, setContractTypes] = useState([])
  const [jobsDomain, setJobsDomain] = useState(undefined)
  const [subJobs, setSubJobs] = useState([])
  const [sectors, setSectors] = useState([])
  const [subSectors, setSubSectors] = useState([])
  const [schoolLevel, setSchoolLevel] = useState([])
  const [experience, setExperience] = useState([])
  const [hasFilters, setHasFilters] = useState(false)
  const [params, setParams] = useState({})
  const [openRespFilters, setOpenRespFilters] = useState(false)

  useEffect(() => {
    setStatus('fetching')
    if (!company) {
      const nameInUrl = location.pathname.split('/')[1]
      getCompany(nameInUrl)
        .then(({ id, careersPageName, name, standalone, jobs }) => {
          const { careersPageLogoId, topLogoId, style, faviconId } = standalone

          const obj = {
            id,
            careersPageName,
            name,
            faviconId,
            logoId: careersPageLogoId || topLogoId,
            theme: {
              primaryColor: style.secondaryColor,
            },
          }

          dispatch(companyFetched(obj))

          setCompany(obj)
          const { data } = jobs

          if (data.length) {
            dispatch(
              jobsFetched({
                jobs: jobs.data.sort(
                  (a, b) => moment(b.createdAt) - moment(a.createdAt),
                ),
              }),
            )

            setJobs(
              data
                .slice()
                .sort((a, b) => moment(b.createdAt) - moment(a.createdAt)),
            )
            const availableLocations = data.map((job) => job.location)
            const availableContract = data.map((job) => job.contractType)
            const availableJobDomain = data
              ?.map((job) => job.jobDomain)
              .flat()
              .filter((e) => e)

            const availableSubDomain = data
              .map((job) => job.subJob)
              .flat()
              .filter((e) => e)
            const availableSectors = data
              .map((job) => job.sector)
              .flat()
              .filter((e) => e)
            const availableSubSectors = data
              .map((job) => job.subSector)
              .flat()
              .filter((e) => e)
            const availableSchoolLevel = data
              .map((job) => job.schoolLevel)
              .flat()
              .filter((e) => e)
            const availableExperience = data
              .map((job) => job.experience)
              .flat()
              .filter((e) => e)

            setLocations(Array.from(new Set(availableLocations)))
            setContractTypes(Array.from(new Set(availableContract)))
            setJobsDomain(Array.from(new Set(availableJobDomain)))
            setSubJobs(Array.from(new Set(availableSubDomain)))
            setSectors(Array.from(new Set(availableSectors)))
            setSubSectors(Array.from(new Set(availableSubSectors)))
            setSchoolLevel(Array.from(new Set(availableSchoolLevel)))
            setExperience(Array.from(new Set(availableExperience)))
          }
        })
        .catch((e) => {
          setStatus('error')
        })
    }

    setStatus('fetched')
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const onFilter = (filters) => {
    const nameInUrl = location.pathname.split('/')[1]
    setFilters(filters)
    setParams({ id: store.company.id, nameInUrl, filter: { ...filters } })
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    if (hasFilters) {
      getFilteredCompany(params).then((result) => {
        setJobs(result)
      })
    } else {
      setJobs(store.company.jobs)
    }
  }, [filters])

  const selectedFilters = Object.values(filters)
    .filter((el) => el)
    .flat()
  if (!company && status !== 'error') {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', marginTop: '25%' }}
      >
        <Loader type="TailSpin" color="#0f6fde" height={30} width={30} />
      </div>
    )
  }
  if (status === 'error') {
    return <ErrorPage statusCode={500} />
  }

  const path = location.pathname
  return (
    <s.AppWrapper>
      <HelmetComponent faviconUrl={company.faviconId} name={company.name} />
      <main className="main">
        <div
          className="companyLogoWrapper"
          style={{
            position:
              path === `/${company.careersPageName}` ? 'fixed' : 'relative',
          }}
        >
          <Link to={`/${company.careersPageName}`}>
            <img
              className="companyLogo"
              src={company.logoId}
              height={50}
              alt={company.name}
            />
          </Link>
          {isSmallScreen ? (
            <Button onClick={() => setOpenRespFilters(true)}>
              <SlidersHorizontal size={35} color="#091a12" />
            </Button>
          ) : null}
        </div>
        <div
          className="content"
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <Route path="/:companyName" exact>
            <>
              {!isSmallScreen ? (
                <div style={{ flexBasis: '20%', minWidth: '20%' }}>
                  <Affix offsetTop={80}>
                    <div
                      style={{
                        // border: '1px solid rgba(0, 0, 0, 0.08)',
                        borderRadius: 8,
                        backgroundColor: 'white',
                      }}
                    >
                      <Filters
                        setHasFilters={setHasFilters}
                        hasFilters={hasFilters}
                        locations={locations}
                        contractTypes={contractTypes}
                        onFilter={onFilter}
                        activeFilters={filters}
                        jobsDomain={jobsDomain}
                        subJobs={subJobs}
                        sectors={sectors}
                        subSectors={subSectors}
                        schoolLevel={schoolLevel}
                        experience={experience}
                      />
                    </div>
                  </Affix>
                </div>
              ) : null}

              <div
                style={{
                  // border: '1px solid rgba(0, 0, 0, 0.08)',
                  borderRadius: 10,
                  flexBasis: isSmallScreen ? '99%' : '85%',
                  marginTop: '60px',
                  display: isSmallScreen && 'flex',
                }}
              >
                <JobList
                  list={hasFilters ? jobs : store.company.jobs}
                  theme={{ theme: company.theme }}
                  selectedFilters={selectedFilters}
                />
              </div>
            </>
          </Route>

          <Route exact path="/:companyName/:jobId" component={JobDetails} />
        </div>
      </main>
      <footer className="footerStyle">
        <p>Powered with &#10084;&#65039; by Hollo</p>
      </footer>
      {openRespFilters && (
        <Drawer
          closable
          visible={openRespFilters}
          width="100%"
          closeIcon={<RiCloseFill size={20} />}
          mask={false}
          onClose={() => setOpenRespFilters(false)}
        >
          <Filters
            setHasFilters={setHasFilters}
            hasFilters={hasFilters}
            locations={locations}
            contractTypes={contractTypes}
            onFilter={onFilter}
            activeFilters={filters}
            jobsDomain={jobsDomain}
            subJobs={subJobs}
            sectors={sectors}
            subSectors={subSectors}
            schoolLevel={schoolLevel}
            experience={experience}
            openRespFilters={openRespFilters}
            setOpenRespFilters={setOpenRespFilters}
          />
        </Drawer>
      )}
    </s.AppWrapper>
  )
}

export default App
